import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../App.css";
import React, { useState, useRef, useEffect, useMemo, useCallback, memo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import "ag-grid-community/styles/ag-theme-material.css";
import Footer from "../Footer/Footer";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import { motion } from "framer-motion";
import GLOBALS from "../../utils/Globals";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";


LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-067893}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{nutrad}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{nutrad_portal}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{nutrad_portal}_need_to_be_licensed___{nutrad_portal}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{29_October_2025}____[v3]_[01]_MTc2MTY5NjAwMDAwMA==71e88be6064d0b1886823ed0ecdbe20c"
);

function Reports() {

    const [rowData, setRowData] = useState();
    const[rowData2, setRowData2] = useState();
    const [rowData3, setRowData3] = useState();

     const [open, setOpen] = useState(false);

     const [type, setType] = useState(false);

     const [selectedRowData, setSelectedRowData] = useState(null);

    const [walmart_feed_id, setWalmart_feed_id] = React.useState(null);
    const [document_id, setDocument_id] = React.useState(null);
    const [processed_at, setProcessed_At] = React.useState(null);
    const [itemsSucceeded, setItemsSucceeded] = React.useState(null);
    const [itemsFailed, setItemsFailed] = React.useState(null);

    const [shopName, setShopName] = React.useState(null);
    const [vendorName, setVendorName] = React.useState(null);
    const [ShopifyTimstamp, setShopifyTimstamp] = React.useState(null);

    const [gdsnType, setGdsnType] = React.useState(null);
    const [gdsnStatus, setGdsnStatus] = React.useState(null);
    const [gdsnStatusCode, setGdsnStatusCode] = React.useState(null);
    const [gdsnItemsProcessed, setGdsnItemsProcessed] = React.useState(null);
    const [gdsnItemsFailed, setGdsnItemsFailed] = React.useState(null);
    const [gdsnTimestamp, setGdsnTimestamp] = React.useState(null);

     const [state, setState] = useState({
       isPaneOpen: false,
       isPaneOpenLeft: false,
     });

  useEffect(() => {
    const baseURLGetWalmartLogs =
      process.env.REACT_APP_ENV === "PROD"
        ? GLOBALS.PROD.baseURLGetWalmartLogs
        : GLOBALS.DEV.baseURLGetWalmartLogs;

    const baseURLGetShopifyLogs =
      process.env.REACT_APP_ENV === "PROD"
        ? GLOBALS.PROD.baseURLGetShopifyLogs
        : GLOBALS.DEV.baseURLGetShopifyLogs;

    const baseURLGetGDSNLogs =
      process.env.REACT_APP_ENV === "PROD"
        ? GLOBALS.PROD.baseURLGetGDSNLogs
        : GLOBALS.DEV.baseURLGetGDSNLogs;

    fetch(baseURLGetWalmartLogs)
      .then((result) => result.json())
      .then((rowData) => setRowData(rowData.data));

    fetch(baseURLGetShopifyLogs)
      .then((result) => result.json())
      .then((rowData2) => setRowData2(rowData2.data));

    fetch(baseURLGetGDSNLogs)
      .then((result) => result.json())
      .then((rowData3) => setRowData3(rowData3.data));
  }, []);

  console.log(rowData);
  console.log(rowData2);
  console.log(rowData3);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      editable: false,
      //filter: true
    };
  });

  const onRowDoubleClicked = useCallback((event) => {
    setSelectedRowData(event.data);

    // Walmart
    setWalmart_feed_id(event.data.walmart_feed_id);
    setDocument_id(event.data.document_id);
    setProcessed_At(event.data.processed_at);
    setItemsFailed(event.data.walmart_feed_status.itemsFailed)
    setItemsSucceeded(event.data.walmart_feed_status.itemsSucceeded)
    //console.log(selectedRowData);
    setType("WALMART");
    setState({ isPaneOpen: true });
  }, []);

  const onRowDoubleClicked2 = useCallback((event) => {
    setSelectedRowData(event.data);

    // Shopify
    setShopName(event.data.shop_name);
    setVendorName(event.data.vendor);
    setShopifyTimstamp(event.data.timestamp);
    // setWalmart_feed_id(event.data.walmart_feed_id);
    // setDocument_id(event.data.document_id);
    // setProcessed_At(event.data.processed_at);
    // setItemsFailed(event.data.walmart_feed_status.itemsFailed);
    // setItemsSucceeded(event.data.walmart_feed_status.itemsSucceeded);
    //console.log(selectedRowData);
    setType("SHOPIFY");
    setState({ isPaneOpen: true });
  }, []);

  const onRowDoubleClicked3 = useCallback((event) => {
    setSelectedRowData(event.data);

    console.log(event.data);

    // GDSN
    setGdsnType(event.data.gdsnType);
    setGdsnItemsFailed(event.data.failed_items);
    setGdsnItemsProcessed(event.data.items_processed);
    setGdsnStatus(event.data.sync_status);
    setGdsnStatusCode(event.data.status_code);
    setType("GDSN");
    setState({ isPaneOpen: true });
  }, []);

  const [colDefs, setColDefs] = useState([
    {
      field: "walmart_feed_id",
      headerName: "WALMART Feed ID",
      filter: "agTextColumnFilter",
    },
    {
      field: "walmart_feed_status.itemsSucceeded",
      headerName: "Items Succeeded",
      filter: "agTextColumnFilter",
    },
    {
      field: "walmart_feed_status.itemsFailed",
      headerName: "Items Failed",
      filter: "agTextColumnFilter",
    },
    {
      field: "document_id",
      headerName: "Document Id",
      filter: "agTextColumnFilter",
    },
    {
      field: "processed_at",
      headerName: "Processed At",
      filter: "agTextColumnFilter",
    },
  ]);

  const [colDefs2, setColDefs2] = useState([
    {
      field: "gtin",
      headerName: "GTIN",
      filter: "agTextColumnFilter",
    },
    {
      field: "product_id",
      headerName: "Product ID",
      filter: "agTextColumnFilter",
    },
    {
      field: "shop_name",
      headerName: "Shop Name",
      filter: "agTextColumnFilter",
    },
    {
      field: "vendor",
      headerName: "Vendor",
      filter: "agTextColumnFilter",
    },
    {
      field: "timestamp",
      headerName: "Timestamp",
      filter: "agTextColumnFilter",
    },
  ]);

    const [colDefs3, setColDefs3] = useState([
      {
        field: "gdsnType",
        headerName: "Type",
        filter: "agTextColumnFilter",
      },
      {
        field: "sync_status",
        headerName: "Sync Status",
        filter: "agTextColumnFilter",
      },
      {
        field: "items_processed",
        headerName: "Items Processed",
        filter: "agTextColumnFilter",
      },
      {
        field: "failed_items",
        headerName: "Failed Items",
        filter: "agTextColumnFilter",
      },
      {
        field: "timestamp",
        headerName: "Timestamp",
        filter: "agTextColumnFilter",
      },
    ]);

  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: false,
    };
  }, []);

  return (
    <>
      <br></br>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold text-gray-900">Audit Logs</h1>
            <br></br>
          </div>
        </div>

        <Tabs
          defaultActiveKey="shopgdsnify"
          id="uncontrolled-tab-example"
          className="mb-3"
        >
          <Tab eventKey="gdsn" title="GDSN">
            <h2>GDSN Logs</h2>
            <div
              className="ag-theme-material" // applying the Data Grid theme
              style={{ height: 800 }}
            >
              <AgGridReact
                rowData={rowData3}
                animateRows={true}
                columnDefs={colDefs3}
                rowSelection={rowSelection}
                //rowClassRules={rowClassRules}
                pagination={true}
                onRowDoubleClicked={onRowDoubleClicked3}
                paginationPageSize={10}
                paginationPageSizeSelector={[10, 20]}
                defaultColDef={defaultColDef}
              />
            </div>
          </Tab>
          <Tab eventKey="gs1" title="GS1">
            <h2>GS1 Logs</h2>
            <div
              className="ag-theme-material" // applying the Data Grid theme
              style={{ height: 800 }}
            >
              <AgGridReact
                rowData={rowData}
                animateRows={true}
                columnDefs={colDefs}
                rowSelection={rowSelection}
                //rowClassRules={rowClassRules}
                pagination={true}
                paginationPageSize={10}
                paginationPageSizeSelector={[10, 20]}
                defaultColDef={defaultColDef}
              />
            </div>
          </Tab>
          <Tab eventKey="shopify" title="Shopify">
            <h2>Shopify Logs</h2>
            <div
              className="ag-theme-material" // applying the Data Grid theme
              style={{ height: 800 }}
            >
              <AgGridReact
                rowData={rowData2}
                animateRows={true}
                columnDefs={colDefs2}
                rowSelection={rowSelection}
                onRowDoubleClicked={onRowDoubleClicked2}
                //rowClassRules={rowClassRules}
                pagination={true}
                paginationPageSize={10}
                paginationPageSizeSelector={[10, 20]}
                defaultColDef={defaultColDef}
              />
            </div>
          </Tab>
          <Tab eventKey="walmart" title="Walmart">
            <h2>Walmart Logs</h2>
            <div
              className="ag-theme-material" // applying the Data Grid theme
              style={{ height: 800 }}
            >
              <AgGridReact
                rowData={rowData}
                animateRows={true}
                columnDefs={colDefs}
                rowSelection={rowSelection}
                //rowClassRules={rowClassRules}
                pagination={true}
                onRowDoubleClicked={onRowDoubleClicked}
                paginationPageSize={10}
                paginationPageSizeSelector={[10, 20]}
                defaultColDef={defaultColDef}
              />
              <SlidingPane
                className="some-custom-class"
                overlayClassName="some-custom-overlay-class"
                isOpen={state.isPaneOpen}
                title="Job Details"
                onRequestClose={() => {
                  // triggered on "<" on left top click or on outside click
                  setState({ isPaneOpen: false });
                }}
              >
                <br />
                <div>Job Details</div>
                <motion.form
                  //onSubmit={handleSubmit}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                  className="bg-white shadow-md rounded-xl p-6 space-y-4"
                >
                  <div className="grid md:grid-cols-2 gap-4">
                    <motion.div
                      whileFocus={{ scale: 1.02 }}
                      className="col-span-full relative"
                    >
                      {type === "WALMART" ? (
                        <>
                          <label>
                            WALMART Feed ID:
                            <input
                              type="text"
                              id="gln"
                              value={walmart_feed_id}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>
                          <br></br>
                          <label>
                            Processed At:
                            <input
                              type="text"
                              id="gln"
                              value={processed_at}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>
                          <br></br>
                          <label>
                            Items Succeeded:
                            <input
                              type="text"
                              id="gln"
                              value={itemsSucceeded}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>
                          <br></br>
                          <label>
                            Items Failed:
                            <input
                              type="text"
                              id="ca"
                              value={itemsFailed}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>
                          <br></br>
                          <br></br>
                          <Button
                            variant="outline-primary"
                            onClick={() => setOpen(!open)}
                            aria-controls="example-collapse-text"
                            aria-expanded={open}
                          >
                            Show Job Details
                          </Button>
                          <br></br>
                          <br></br>
                          <Collapse in={open}>
                            <div id="example-collapse-text">
                              <JsonView src={selectedRowData} />
                            </div>
                          </Collapse>
                        </>
                      ) : type === "SHOPIFY" ? (
                        <>
                          <label>
                            Shopname:
                            <input
                              type="text"
                              id="gln"
                              value={shopName}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>
                          <br></br>
                          <label>
                            Vendor:
                            <input
                              type="text"
                              id="gln"
                              value={vendorName}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>
                          <br></br>
                          <label>
                            Timestamp:
                            <input
                              type="text"
                              id="gln"
                              value={ShopifyTimstamp}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>
                          <br></br>

                          <br></br>
                          <br></br>
                          <Button
                            variant="outline-primary"
                            onClick={() => setOpen(!open)}
                            aria-controls="example-collapse-text"
                            aria-expanded={open}
                          >
                            Show Job Details
                          </Button>
                          <br></br>
                          <br></br>
                          <Collapse in={open}>
                            <div id="example-collapse-text">
                              <JsonView src={selectedRowData} />
                            </div>
                          </Collapse>
                        </>
                      ) : (
                        <>
                          <label>
                            Type:
                            <input
                              type="text"
                              id="gln"
                              value={gdsnType}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>
                          <br></br>
                          <label>
                            Sync Status:
                            <input
                              type="text"
                              id="gln"
                              value={gdsnStatus}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>
                          <br></br>
                          <label>
                            Items Processed:
                            <input
                              type="text"
                              id="gln"
                              value={gdsnItemsProcessed}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>

                          <br></br>
                          <label>
                            Items Failed:
                            <input
                              type="text"
                              id="gln"
                              value={gdsnItemsFailed}
                              //onChange={handleChange}
                              className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                              placeholder="GLN"
                              required
                            />
                          </label>
                          <br></br>
                          <br></br>
                          <Button
                            variant="outline-primary"
                            onClick={() => setOpen(!open)}
                            aria-controls="example-collapse-text"
                            aria-expanded={open}
                          >
                            Show Job Details
                          </Button>
                          <br></br>
                          <br></br>
                          <Collapse in={open}>
                            <div id="example-collapse-text">
                              <JsonView src={selectedRowData} />
                            </div>
                          </Collapse>
                        </>
                      )}

                      <br></br>
                    </motion.div>
                  </div>
                </motion.form>
              </SlidingPane>
            </div>
          </Tab>
        </Tabs>
      </div>
      <Footer />
    </>
  );
}

export default Reports;
